
import React from 'react';
import { MessageCircle } from 'lucide-react';
import { SiteSettings } from '../types';

interface WhatsappFloatingButtonProps {
  settings: SiteSettings;
}

const WhatsappFloatingButton: React.FC<WhatsappFloatingButtonProps> = ({ settings }) => {
  if (!settings.whatsappNumber) return null;

  const currentUrl = window.location.href;
  const message = encodeURIComponent(`Olá! Estou no site ${currentUrl} e gostaria de mais informações.`);
  const whatsappUrl = `https://wa.me/${settings.whatsappNumber.replace(/\D/g, '')}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-6 lg:bottom-8 lg:right-8 z-[140] w-14 h-14 md:w-16 md:h-16 transition-all transform hover:scale-110 active:scale-95 drop-shadow-lg group"
      aria-label="Contato via WhatsApp"
    >
      <svg 
        viewBox="0 0 32 32" 
        className="w-full h-full drop-shadow-md" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* White outer border/shape - thinner now */}
        <path 
          d="M16 0C7.163 0 0 7.163 0 16c0 2.825.733 5.479 2.014 7.787L0 32l8.442-2.014A15.91 15.91 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0z" 
          fill="#fff" 
        />
        {/* Green inner shape (creates the thin white border effect) */}
        <path 
          d="M16 0.6C7.495 0.6 0.6 7.495 0.6 16c0 2.707.7 5.247 1.928 7.452L0.4 30.8l7.716-1.842A15.2 15.2 0 0 0 16 31.4c8.505 0 15.4-6.895 15.4-15.4S24.505 0.6 16 0.6z" 
          fill="#25D366" 
        />
        {/* White phone icon */}
        <path 
          d="M21.507 18.533c-.3-.15-1.773-.875-2.047-.975-.275-.1-.475-.15-.675.15s-.775.975-.95 1.175-.35.225-.65.075c-.3-.15-1.267-.467-2.413-1.488-.892-.796-1.494-1.779-1.669-2.079-.175-.3-.019-.463.131-.612.135-.134.3-.35.45-.525.15-.175.2-.3.3-.5s.05-.375-.025-.525-.675-1.625-.925-2.225c-.244-.584-.491-.505-.675-.514-.175-.008-.375-.01-.575-.01s-.525.075-.8.375c-.275.3-1.05 1.025-1.05 2.5s1.075 2.9 1.225 3.1c.15.2 2.113 3.227 5.119 4.525.715.309 1.273.494 1.708.632.718.229 1.371.196 1.887.119.575-.086 1.773-.725 2.023-1.425.25-.7.25-1.3.175-1.425-.075-.125-.275-.2-.575-.35z" 
          fill="#fff" 
        />
      </svg>
      {/* Notification dot */}
      <div className="absolute top-1 right-1 w-4 h-4 bg-red-500 border-2 border-white rounded-full animate-pulse"></div>
    </a>
  );
};

export default WhatsappFloatingButton;
